import { call, put, takeLatest } from 'redux-saga/effects';
import { generateToast } from 'containers/App/actions';
import {
  fetchUsersSuccess,
  fetchUsersFailure,
  deactivateUserSuccess,
  deactivateUserFailure,
  reactivateUserSuccess,
  reactivateUserFailure,
} from './actions';
import { fetchUsersApi, deactivateUserApi, reactivateUserApi } from './api';
import { FETCH_USERS, DEACTIVATE_USER, REACTIVATE_USER } from './constants';

export function* performFetchUsers() {
  try {
    const result = yield call(fetchUsersApi);
    yield put(fetchUsersSuccess(result.data));
  } catch (err) {
    yield put(
      fetchUsersFailure(
        err.response?.data?.error || 'Failed to fetch users',
      ),
    );
  }
}

export function* performDeactivateUser(action) {
  try {
    yield call(deactivateUserApi, action.userId);
    yield put(deactivateUserSuccess());
    yield put(generateToast({ type: 'success', text: 'User deactivated successfully' }));
  } catch (err) {
    yield put(
      deactivateUserFailure(
        err.response?.data?.error || 'Failed to deactivate user',
      ),
    );
  }
}

export function* performReactivateUser(action) {
  try {
    yield call(reactivateUserApi, action.userId);
    yield put(reactivateUserSuccess());
    yield put(generateToast({ type: 'success', text: 'User reactivated successfully' }));
  } catch (err) {
    yield put(
      reactivateUserFailure(
        err.response?.data?.error || 'Failed to reactivate user',
      ),
    );
  }
}

export default function* manageAccountStatusSaga() {
  yield takeLatest(FETCH_USERS, performFetchUsers);
  yield takeLatest(DEACTIVATE_USER, performDeactivateUser);
  yield takeLatest(REACTIVATE_USER, performReactivateUser);
}
